import { DashboardPieChartDto } from './../../../../service/dto';
import { Component, Input } from '@angular/core';

// kenya-restyle.md §6: Highcharts' free tier stamps a "highcharts.com"
// watermark on every rendered chart, and licensing it was explicitly
// ruled out — so pie charts (only; the bar/line/gauge dashboard
// widgets elsewhere keep Highcharts and are out of this restyle's
// scope) are redrawn as a dependency-free inline SVG donut instead,
// using the same classic stroke-dasharray/-dashoffset technique the
// Polaris reporting view's donut uses. The `input` binding's shape
// (DashboardPieChartDto: title + slices[].label/.value) is unchanged.
const DONUT_COLORS = ['#0048b4', '#5c636d', '#8aa9d6', '#b9c0cb', '#1a7a5e', '#b6641a', '#003590'];
const RADIUS = 60;
const STROKE_WIDTH = 22;

interface DonutSlice {
	label: string;
	value: number;
	pct: number;
	color: string;
	dashArray: string;
	dashOffset: number;
}

@Component({
	selector: 'app-dashboard-pie-chart',
	standalone: false,
	templateUrl: './dashboard-pie-chart.component.html',
	styleUrl: './dashboard-pie-chart.component.scss'
})
export class DashboardPieChartComponent {
	_input!: DashboardPieChartDto;
	radius = RADIUS;
	strokeWidth = STROKE_WIDTH;
	viewBoxSize = (RADIUS + STROKE_WIDTH) * 2;
	circumference = 2 * Math.PI * RADIUS;
	donutSlices: DonutSlice[] = [];
	total = 0;

	@Input()
	set input(input: DashboardPieChartDto) {
		this._input = input;
		this.total = input.slices.reduce((sum, item) => sum + (item.value ?? 0), 0);

		let cumulativePct = 0;
		this.donutSlices = input.slices.map((item, index) => {
			const pct = this.total > 0 ? (item.value / this.total) * 100 : 0;
			const dashLength = (pct / 100) * this.circumference;
			const slice: DonutSlice = {
				label: item.label,
				value: item.value,
				pct,
				color: DONUT_COLORS[index % DONUT_COLORS.length],
				dashArray: `${dashLength} ${this.circumference - dashLength}`,
				dashOffset: -((cumulativePct / 100) * this.circumference)
			};
			cumulativePct += pct;
			return slice;
		});
	}

	get title(): string {
		return this._input?.title ?? '';
	}
}
